import { ComponentProps, ComponentRef } from "@ionic/core";
import { modalController } from "@ionic/vue";

interface modalOpts<T extends ComponentRef = ComponentRef> {
  component: T;
  presentingElement?: HTMLElement;
  componentProps?: ComponentProps<T>;
}

export const openModalFn = <T extends ComponentRef = ComponentRef>({
  component,
  presentingElement,
  componentProps,
}: modalOpts<T>): (() => Promise<HTMLIonModalElement>) => {
  const props = {
    onConfirm: () => modalController.dismiss(null, "confirm"),
    onCancel: () => modalController.dismiss(null, "cancel"),
    ...componentProps,
  };

  return async () => {
    const modal = await modalController.create({
      component,
      presentingElement,
      canDismiss: true,
      componentProps: props,
      backdropDismiss: false,
      keyboardClose: false,
    });

    await modal.present();
    return modal;
  };
};
